export const IMAGE_LOADING = {
    lazy: 'lazy',
} as const

export const IMAGE_TYPE = {
    flex: 'flex',
    square: 'square',
} as const
